import { render, staticRenderFns } from "./add.vue?vue&type=template&id=a7842a22&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=a7842a22&lang=scss&"
import style1 from "./add.vue?vue&type=style&index=1&id=a7842a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7842a22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7842a22')) {
      api.createRecord('a7842a22', component.options)
    } else {
      api.reload('a7842a22', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=a7842a22&scoped=true&", function () {
      api.rerender('a7842a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/template/add.vue"
export default component.exports